/** Campo utilizado somente quando ric_tipo = 5 (Devolução) */
export enum DevolucaoOperacao {
    Compra = 1,
    Venda = 2,
}
